<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("certificateOperationPrint.candidate")
          }}</label>
          <a-select
            class="tw-w-full"
            show-search
            option-filter-prop="children"
            allowClear
            v-model="model.candidate_id"
            @change="onCandidate()"
            :class="{
              'is-invalid': errors.has('candidate_id'),
            }"
          >
            <a-select-option
              v-for="(candidate, index) in candidatesList"
              :key="index"
              :value="candidate.candidate_id"
            >
              {{ candidate.full_name_en }} |
              {{ candidate.full_name_kh }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('candidate_id')">
            {{ errors.first("candidate_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("certificateOperationPrint.certificate")
          }}</label>
          <a-select
            class="tw-w-full"
            v-model="model.certificate_id"
            :class="{
              'is-invalid': errors.has('certificate_id'),
            }"
          >
            <a-select-option
              v-for="(certificate, index) in certificateLists"
              :key="index"
              :value="certificate.certificate_id"
            >
              {{ certificate.level_skill_name }} | LeveL:
              {{ certificate.skill_level_order }} |
              {{ certificate.cert_type_name }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('certificate_id')">
            {{ errors.first("certificate_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("certificateOperationPrint.requestDate")
          }}</label>
          <a-date-picker
            v-model="model.requesting_date"
            style="width: 100%"
            placeholder="DD-MM-YYYY"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            @change="onChangeRequestDate"
            :class="{
              'is-invalid': errors.has('requesting_date'),
            }"
          />
          <div class="invalid-feedback" v-if="errors.has('requesting_date')">
            {{ errors.first("requesting_date") }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          >
          <ts-button
            v-if="!isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t("save") }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  name: "certificateOperationPrintForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      candidates: [],
      certificates: [],
      model: {
        candidate_id: null,
        certificate_id: null,
        is_approved: false,
        is_printed: false,
        reach_candidate: false,
        requesting_date: moment().format("DD-MM-YYYY"),
        minute_meeting_date: null,
        certificate_type: null,
      },
    };
  },
  computed: {
    ...mapState("academic/certificateOperationPrint", [
      "edit_data",
      "formViewDatas",
    ]),
    candidatesList() {
      return this.candidates;
    },
    certificateLists() {
      return this.certificates;
    },
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    await this.setEditData();
    await this.fetchFormViewModel({ index: undefined });
  },
  methods: {
    ...mapActions("academic/certificateOperationPrint", ["getFormViewData"]),
    async fetchFormViewModel({ index }) {
      this.waiting = true;
      await this.getFormViewData({
        index: index,
        params: {
          candidate_id: this.edit_data.candidate_id,
        },
      });
      this.candidates = this.formViewDatas["candidates"];
      this.certificates = this.formViewDatas["certificate"];
      this.waiting = false;
    },
    onChangeMinuteMeetingDate(dateString) {
      this.model.issue_date = dateString;
    },
    async onCandidate() {
      this.waiting = true;
      this.model.certificate_id = null;
      this.model.certificate_type = null;
      this.model.minute_meeting_date = null;
      await this.getFormViewData({
        index: "certificate",
        params: {
          fnName: "certificate",
          candidate_id: this.model.candidate_id,
        },
      });
      this.certificates = this.formViewDatas["certificate"];
      this.waiting = false;
    },
    onChangeRequestDate(dateString) {
      this.model.requesting_date = dateString;
    },
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("academic/certificateOperationPrint/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/certificateOperationPrint/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/certificateOperationPrint/update", {
          id: this.edit_data.printing_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "errors", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearEdit() {
      this.model.candidate_id = null;
      this.model.certificate_id = null;
      this.model.requesting_date = moment().format("DD-MM-YYYY");
      this.model.is_approved = false;
      this.model.is_printed = false;
      this.model.reach_candidate = false;
      this.model.minute_meeting_date = null;
      this.model.certificate_type = false;
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.candidate_id = this.edit_data.candidate_id;
        this.model.certificate_id = this.edit_data.certificate_id;
        this.model.requesting_date = this.edit_data.requesting_date;
        this.model.is_approved = this.edit_data.is_approved;
        this.model.is_printed = this.edit_data.is_printed;
        this.model.reach_candidate = this.edit_data.reach_candidate;
        this.model.minute_meeting_date = this.edit_data.minute_meeting_date;
        this.model.certificate_type = this.edit_data.certificate_type;
      }
    },
    certificateType() {
      if (this.model.certificate_id) {
        let certificateData = this.certificates.find(
          (e) => e.certificate_id == this.model.certificate_id
        );
        this.model.certificate_type = certificateData.cert_type_id;
        this.model.minute_meeting_date = certificateData.exam_date;
      }
    },
  },
  watch: {
    "model.certificate_id": {
      handler() {
        this.certificateType();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>